import store from "store";

import { getItem, setItem } from "../cookie";

const COOKIE = "darkMode";
const A_YEAR = 60 * 60 * 24 * 365;

/**
 * The preference is kept in a cookie, not in local storage: the server renders the page
 * in one theme or the other, and a cookie is the only one of the two it gets to see.
 */
export const saveDarkMode = (mode: boolean) => {
    setItem(COOKIE, mode.toString(), A_YEAR);
};

/**
 * What the browser can work out for itself, in the order the answers are worth trusting:
 * the cookie the server was meant to read, the choice earlier versions left behind in
 * local storage, and failing both, the operating system.
 *
 * The caller applies this after hydration rather than before the first render, which has
 * to stay identical to the markup it is hydrating. In production it agrees with what the
 * server already read out of the cookie, so nothing changes; in development, where the
 * server renders no state at all, this is the only thing that knows.
 */
export const resolveDarkMode = () => {
    const cookie = getItem(COOKIE);
    if (cookie !== null) return cookie === "true";
    const stored = store.get("darkMode");
    if (stored !== undefined && stored !== null) return String(stored) === "true";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
};
